module.exports = __webpack_public_path__ + "img/business board-no-text.bd383d62.svg";